import openingtimesService from '../../services/openingtimes'
import TimeFormatter from '../../../src/assets/js/TimeFormatter'
const state = {
    openingtimes: []
}

// getters
const getters = {
    getOpeningTimeByLabel: (state) => (label) => {
        return state.openingtimes.find(o => o.label === label);
    }
}

// actions
const actions = {
    async getOpeningTimesAction(context) {
        await openingtimesService.getOpeningTimesFromRestaurant()
                                 .then(data => { context.commit('setOpeningTimesState', data) });
    },
    async updateOpeningTimeAction(context, openingtime) {
        openingtime.fromTime = TimeFormatter.timeToString(openingtime.fromTime);
        openingtime.toTime = TimeFormatter.timeToString(openingtime.toTime);
        openingtime.canOrderFrom = TimeFormatter.timeToString(openingtime.canOrderFrom);
        openingtime.cannotOrderFrom = TimeFormatter.timeToString(openingtime.cannotOrderFrom);
        openingtime.rushHourFrom = TimeFormatter.timeToString(openingtime.rushHourFrom);
        openingtime.rushHourTo = TimeFormatter.timeToString(openingtime.rushHourTo);
        await openingtimesService.updateOpeningTime(openingtime.label, openingtime);
        context.commit('updateOpeningTimeState', openingtime);
    }
}

// mutations
const mutations = {
    setOpeningTimesState(state, openingtimes) {
        state.openingtimes = openingtimes;
    },
    updateOpeningTimeState(state, openingtime) {
        let index = state.openingtimes.findIndex(ot => ot.label === openingtime.label);
        if (index > -1) {
            state.openingtimes[index] = openingtime;
        }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}